import React from "react";
import PropTypes from "prop-types";
import {Modal} from "../../components/Modal";
import {i18nFormat} from "../../lib/i18nFormat";

export function BackupDeleteDialog(props) {
  if (!props.isOpen) {
    return null;
  }

  function handleDeleteConfirmClick() {
    // Execute deletion through provided handler and close dialog
    Promise.resolve()
      .then(() => props.onDelete(props.backup))
      .finally(() => props.onClose());
  }

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <div className="account-backup-delete-dialog">
        <button className="account-backup-delete-dialog__close-button glyph-core-cross" onClick={props.onClose}>
        </button>
        <div className="account-backup-delete-dialog__icon-wrapper account-backup-delete-dialog__icon-wrapper--delete">
          <div className="glyph-core-trash-fill"/>
        </div>
        <h2 className="account-backup-delete-dialog__title">
          {i18nFormat("backups.delete-dialog.title")}
        </h2>
        <p className="account-backup-delete-dialog__description">
          {i18nFormat("backups.delete-dialog.description")}
        </p>
        <div className="account-backup-delete-dialog__buttons">
          <button className="account-backup-delete-dialog__cancel-button" onClick={props.onClose}>
            {i18nFormat("backups.delete-dialog.cancel")}
          </button>
          <button className="account-backup-delete-dialog__delete-button" onClick={handleDeleteConfirmClick}>
            {i18nFormat("backups.delete-dialog.confirm")}
          </button>
        </div>
      </div>
    </Modal>
  );
}

BackupDeleteDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  backup: PropTypes.shape({
    backupId: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
};